import {getField, updateField} from 'vuex-map-fields';

const state = {
    facturacion: [],
    filters: {
        mes: 'all',
        usuario: 'all',
        sede: 'all',
        range: []
    },
    vehiculo_filters: {
        usuario: 'all',
        sede: 'all',
        range: []
    },

}

const getters = {
    getField,
}

const mutations = {
    updateField,
    updateFacturacion: (state, payload) => {
        state.facturacion = payload;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations
}
